export default "__VITE_ASSET__CvZR8yEm__"